module.exports = __webpack_public_path__ + "static/media/gray-triangle-right.344e6835.svg";